import { render, staticRenderFns } from "./DetailSurgeryBloodTest.vue?vue&type=template&id=6de34617&scoped=true&"
import script from "./DetailSurgeryBloodTest.vue?vue&type=script&lang=js&"
export * from "./DetailSurgeryBloodTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de34617",
  null
  
)

export default component.exports